
import React from 'react';
import { Redirect } from 'react-router';
import { useHistory } from 'react-router-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import CreateAccountForm from '../../common/client/components/CreateAccountForm';
import Text from '../../common/client/components/Text';
import AppPageStyle from '../../common/client/components/mysliveckyportal/AppPageStyle';
import useAuthIsLogged from '../../common/client/hooks/mysliveckyportal/useAuthIsLogged';

import useNavigationItems  from '../../hooks/useNavigationItems';

import AuthLink from './AuthLink';
import AuthLinks from './AuthLinks';

const classNames = mergeStyleSets({
    CreateAccountPage: {
    },
    panel: {
        backgroundColor: '#ffffff',
        marginTop: 64,
        marginBottom: 64,
        padding: 8,
        border: '1px solid #999999',
        width: 430
    },
});

const Content = ({logged}) => {
    const history = useHistory();

    if (logged) {
        return <Redirect to="/" />;
    }

    const handleCancelClick = () => {
        history.push('/');
    }

    return (
        <CreateAccountForm
            onCancelClick={handleCancelClick}
        />
    );
}

const LinkLogin = () => {
    return (
        <AuthLink page="login" title="Přihlášení existujícího uživatele" />
    );
}

const CreateAccountPage = () => {

    const logged = useAuthIsLogged();
    const navigationItems = useNavigationItems();

    return (
        <AppPageStyle
            navigationItems={navigationItems}
        >
            <Stack className={classNames.CreateAccountPage}>
                <Stack.Item className={classNames.panel} align="center">
                    <Text xxLarge>Registrace nového uživatele</Text>
                    <Content
                        logged={logged}
                    />
                    <AuthLinks>
                        <LinkLogin />
                    </AuthLinks>
                </Stack.Item>
            </Stack>
        </AppPageStyle>
    );
}

export default CreateAccountPage;
